import path from "path";

import { readFormConfig } from "../../BuildTasks/ResolveFormInfo";
import { ConsoleApplicationContext } from "../../Commons/ConsoleApplication/ConsoleApplicationContext";
import { FormGlobs } from "../../Commons/FormGlobsUtils";
import { iterateEntries } from "../../../../Common/IterableUtils";
import { WellKnownDirectories } from "../../../../Common/WellKnownDirectories";

import { FormStatsOptions } from "./FormStatsOptions";

export async function runFormStats(
    context: ConsoleApplicationContext,
    options: FormStatsOptions,
    farmDirectory: string
): Promise<void> {
    const formGlobs = await FormGlobs.resolveSpecifiers(options.formGlobs, farmDirectory);

    const engineToGfvMap: Record<string, string[]> = {};
    for (const { gfv, formPath } of await FormGlobs.resolveGfvGlobs(formGlobs, farmDirectory)) {
        try {
            const formJsonContent = await readFormConfig(path.join(formPath, WellKnownDirectories.FormJsonFileName));
            let engineBranch: string;
            if (formJsonContent.mode === "no-editor") {
                engineBranch = "NoEditor";
            } else {
                engineBranch = formJsonContent.dependencies?.engine ?? "Unknown";
            }
            engineToGfvMap[engineBranch] = engineToGfvMap[engineBranch] ?? [];
            engineToGfvMap[engineBranch]?.push(gfv);
        } catch {
            engineToGfvMap["Unknown"] = engineToGfvMap["Unknown"] || [];
            engineToGfvMap["Unknown"].push(gfv);
        }
    }

    for (const [engine, engineGfvs] of iterateEntries(engineToGfvMap)) {
        context.logger.log(engine);
        context.logger.log(`  ${engineGfvs.length} forms`);
    }
    context.logger.log("");
    for (const [engine, gfvs] of Object.entries(engineToGfvMap)) {
        context.logger.log(engine);
        context.logger.log(`  ${gfvs.join(", ")}`);
    }
}
